import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stock",
  "use": "icon-stock-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol viewBox=\"0 0 20 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-stock\">\n<path d=\"M17 0C17.5523 0 17.8204 0.5939 18.0125 1.14626C18.2046 1.69861 20 9 20 9V17C20 17.5523 19.5523 18 19 18H1C0.44772 18 0 17.5523 0 17V9C0 9 1.84675 1.54628 2 1C2.15325 0.453717 2.44772 0 3 0H17ZM5.41604 11H2V16H18V11H14.584C13.8124 12.7659 12.0503 14 10 14C7.94968 14 6.1876 12.7659 5.41604 11ZM16 2H4L2 9H7C7 10.6569 8.3431 12 10 12C11.6569 12 13 10.6569 13 9H18L16 2Z\" fill=\"#F3AD02\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol